import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { InputGroup, SubmitBtn, ActionSection, SideCancelBtn, Wrapper, FieldWrappers, ScrollableContent } from "../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import { Formik, Form, Field, ErrorMessage } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { UserImage, ProfileSection, UserInfo, Underline } from "../Styles/PageStyles";
import Images from "../../Images";
import { capitalizeFirstLetter } from "../../helpers";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendar } from "react-icons/fa";
import moment from "moment";

const EditLead = ({ handleClose, selectedData, editLeadLoading, editLeadMutate, setViewDetail }) => {
    const [calendarOpen, setCalendarOpen] = useState(false);

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const initialValues = {
        name: selectedData?.name || "N/A",
        propertyName: selectedData?.propertyName || "N/A",
        status: selectedData?.status?.toString() || "",
        remark: selectedData?.remarks || "",
        visitDate: selectedData?.visitDateTime
            ? selectedData.visitDateTime.split(" ")[0]
            : "",
        visitTime: selectedData?.visitDateTime
            ? selectedData.visitDateTime.split(" ")[1].slice(0, 5)
            : "",
    };

    const handleSubmit = (values) => {

        if ((values.status === "3" || values.status === "2") && (!values.visitDate || !values.visitTime)) {
            toast.error("Visit date and time are required for 'Visit Scheduled' status");
            return;
        }

        if (!values.status) {
            toast.error("Status is required");
            return;
        }

        const payload = {
            id: selectedData?.id,
            // visitDateTime: values.visitDate + " " + values.visitTime,
            visitDateTime: values.status === "3" || values.status === "2" ? values.visitDate + " " + values.visitTime : undefined,
            remarks: values.remark,
            status: Number(values.status),
        };
        editLeadMutate(payload);
    };

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <Header>

                <h1 className="text-white text-lg font-medium">Edit Lead</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>
            <ProfileSection>

                <UserInfo>
                    <span className="font-medium">{capitalizeFirstLetter(selectedData?.name)}</span>
                    <span className="text-sm text-gray-600">
                        {selectedData?.linkedProperties?.length > 0
                            ? selectedData.linkedProperties.map((prop, index) => (
                                <span key={prop.id}>
                                    {prop.name}
                                    {index !== selectedData.linkedProperties.length - 1 && ', '}
                                </span>
                            ))
                            : <span className="text-gray-400">-</span>
                        }
                    </span>
                </UserInfo>

            </ProfileSection>
            <Content>
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
                        <Form className="flex flex-col h-full justify-between">
                            <ScrollableContent className="max-h-[calc(100vh-100px)]">
                                <Wrapper className="mt-0">

                                    {/* Status Dropdown */}
                                    <InputGroup>
                                        <Label htmlFor="status">Status *</Label>
                                        <FieldWrapper $select={true}>
                                            <Field
                                                name="status"
                                                as={Select}
                                                id="status"
                                                value={values.status}
                                                // onChange={handleChange}
                                                onChange={(e) => {
                                                    handleChange(e);

                                                    if (e.target.value !== "3" || e.target.value !== "2") {
                                                        setFieldValue("visitDate", "");
                                                        setFieldValue("visitTime", "");
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                                className="w-full pl-2"
                                                style={{ height: "46px" }}
                                                displayEmpty
                                            >
                                                <MenuItem value="">Select Status</MenuItem>
                                                <MenuItem value="1">New</MenuItem>
                                                <MenuItem value="2">Follow Up</MenuItem>
                                                <MenuItem value="3">Visit Scheduled</MenuItem>
                                                <MenuItem value="4">Visit Done</MenuItem>
                                                <MenuItem value="5">Moved In</MenuItem>
                                                <MenuItem value="6">Not Interested</MenuItem>
                                                <MenuItem value="7">Contacted</MenuItem>
                                                <MenuItem value="8">Interested</MenuItem>
                                                <MenuItem value="9">Invalid</MenuItem>
                                                <MenuItem value="10">Onhold</MenuItem>
                                                <MenuItem value="11">Not Answered</MenuItem>
                                                <MenuItem value="12">Lost</MenuItem>
                                            </Field>

                                        </FieldWrapper>
                                    </InputGroup>
                                    {(values.status === "3" || values.status === "2") && (
                                        <InputGroup>
                                            <Label htmlFor="visitDateTime">Visit Date & Time *</Label>
                                            <FieldWrappers className="relative">

                                                <DatePicker
                                                    selected={values.visitDate ? new Date(`${values.visitDate}T${values.visitTime || '00:00'}`) : null}
                                                    onChange={(date) => {
                                                        const dateStr = moment(date).format("YYYY-MM-DD");
                                                        const timeStr = moment(date).format("HH:mm");
                                                        handleChange({
                                                            target: {
                                                                name: "visitDate",
                                                                value: dateStr
                                                            }
                                                        });
                                                        handleChange({
                                                            target: {
                                                                name: "visitTime",
                                                                value: timeStr
                                                            }
                                                        });
                                                    }}
                                                    onClickOutside={() => setCalendarOpen(false)}
                                                    onSelect={() => setCalendarOpen(false)}
                                                    open={calendarOpen}
                                                    onInputClick={() => setCalendarOpen(true)}
                                                    showTimeSelect
                                                    timeFormat="HH:mm"
                                                    timeIntervals={15}
                                                    dateFormat="MMMM d, yyyy h:mm aa"
                                                    className="w-full cursor-pointer"
                                                    placeholderText="Select date and time"
                                                    required
                                                    name="visitDateTime"
                                                    id="visitDateTime"
                                                    autoComplete="off"
                                                    showIcon
                                                    icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                    showPopperArrow={false}
                                                    onFocus={(e) => e.target.blur()}
                                                    wrapperClassName="w-full"
                                                    minDate={new Date()}
                                                    portalId="root-portal"
                                                    popperClassName="react-datepicker-popper"
                                                />
                                            </FieldWrappers>
                                        </InputGroup>
                                    )}
                                    {/* Remarks */}
                                    <InputGroup>
                                        <Label htmlFor="remark">Notes</Label>
                                        <FieldWrapper>
                                            <Field
                                                as={Textarea}
                                                id="remark"
                                                name="remark"
                                                rows={5}
                                                placeholder="Enter Remarks (Optional)"
                                            />

                                        </FieldWrapper>
                                    </InputGroup>

                                </Wrapper>
                            </ScrollableContent>
                            {/* Actions */}
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleClose}>
                                    Back
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={editLeadLoading}>{editLeadLoading ? "Loading..." : "Submit"}</SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </Content>
        </Container>
    );
};

// const Wrapper = tw.div`grid gap-4 my-6`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium text-center`;
// const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Textarea = tw.textarea`min-h-30 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200 w-full h-30 resize-y break-words overflow-hidden`;
const FieldWrapper = tw.div`w-full`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Content = tw.div`p-4 flex flex-col gap-4 mb-10`;
// const Content = tw.div`px-4 h-full flex flex-col justify-between pb-4 relative`;
const Label = tw.label`text-sm text-gray-500 font-normal`;
const Input = tw.input`truncate border border-gray-300 rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default EditLead;


